import { apiClient } from './apiClient'

export const permissionApi = {
    fetchPermissionDefinitions: async (config, accessToken) => {
        if (accessToken == null) {
            throw Error("fetchPermissionDefinitions: Access token is null")
        }
        const url = `${config.securityApiUrl}/permissions`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.permission
                    }
                )
            }
        )
    }
}